import React, { useContext, useState } from 'react'
import { Row, Col, message, Card, Switch } from 'antd'
import './dashboard.scss'
import email_icon from '../../assets/email.svg'
import dashboardService from '../../services/dashboardService'
import { Button } from 'react-bootstrap'
import { useOutletContext } from 'react-router-dom'
import { ThemeContext } from '../../context/themeProvider'

const EmailOptIn = () => {
  const props = useOutletContext()
  let profileDetails = dashboardService.getUserProfile()
  const [isEmailSent, setIsEmailSent] = useState(false)
  const [handleOptBtn, setHandleOptBtn] = useState(false)
  const { setLoading } = useContext(ThemeContext)

  const sendOptInEmail = async () => {
    try {
      setHandleOptBtn(true)
      setLoading(true)
      const response = await dashboardService.sendOptInRequest()
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy()
        message.error(response?.error?.message || 'Something went worng in send request')
      } else {
        message.destroy()
        message.success(response?.message || 'Request sent successfully')
        setIsEmailSent(true)
      }
    } catch (error) {
      // message.destroy()
      // message.error(error?.response?.data?.message || 'Link Invalid or Expired')
    }
    setLoading(false)
    setHandleOptBtn(false)
  }

  const toggleEmailSubscription = async () => {
    let dataToSend = {
      emailSubscription: !profileDetails?.userDetails?.emailSubscription,
    }
    try {
      setHandleOptBtn(true)
      setLoading(true)
      const response = await dashboardService.updateProfileImage(dataToSend)
      if (response.error) {
        message.destroy()
        message.error(response?.error?.message || 'Something went worng in getting user details')
      } else {
        message.success(response?.message)
        props.getDetailsFunc()
      }
    } catch (error) {}
    setLoading(false)
    setHandleOptBtn(false)
  }
  return (
    <Row className="mt-3">
      <Col
        lg={24}
        xs={24}
      >
        <Card className={`dashboard_product__about_ui`}>
          <Row align="middle">
            <Col
              lg={16}
              xs={24}
            >
              <h1>Stay informed about BAAI</h1>
              <p>We will send you our future updates including rewards, airdrops, upcoming events, latest news and more. Your privacy is our top priority, therefore we will only send you information that is relevant to BAAI.</p>
            </Col>
            <Col
              lg={8}
              xs={24}
              align="end"
            >
              {profileDetails?.userDetails?.isVerified ? (
                <div className="mt-3">
                  <label>Receive Future Updates</label>{' '}
                  <Switch
                    checked={profileDetails?.userDetails?.emailSubscription}
                    onChange={() => toggleEmailSubscription()}
                    disabled={handleOptBtn}
                  />
                  <p className="text-primary mt-3">
                    Email Verified{' '}
                    <span>
                      {' '}
                      <img
                        width="20"
                        src={email_icon}
                        alt=""
                      />{' '}
                    </span>
                  </p>
                </div>
              ) : isEmailSent ? (
                <div>
                  <Button variant="primary">Email sent!</Button>
                  <p
                    className="text-danger mt-1"
                    style={{ fontSize: '12px' }}
                  >
                    Check your email for verification link
                  </p>
                </div>
              ) : (
                <div className="d-flex justify-content-end">
                  <Button
                    variant="primary"
                    onClick={() => sendOptInEmail()}
                    disabled={handleOptBtn}
                  >
                    Send me updates
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

export default EmailOptIn
